import { HAS_WINDOW } from '@eventbrite/feature-detection';

const isScrollStyleValue = (value) => value === 'auto' || value === 'scroll';

/**
 * Determines whether a given dom element is scrollable
 * @param {Element} element - DOM element to inspect
 * @returns {boolean}
 */
export const canScroll = (element) => {
    // window is necessary to use getComputedStyle
    if (!HAS_WINDOW) {
        return null;
    }

    const styles = getComputedStyle(element);

    return (
        isScrollStyleValue(styles.overflow) ||
        isScrollStyleValue(styles.overflowX) ||
        isScrollStyleValue(styles.overflowY)
    );
};

/**
 * Returns the first scrollable ancestor that is scrollable.
 * Migrated from js-utils/dom, refactor to a package if re-using
 * @param {Element} element - DOM element on which to find scroll ancestor
 * @returns {Element}
 */
export const getScrollAncestor = (element) => {
    if (!element || !element.parentElement) {
        return null;
    }

    let currentElement = element.parentElement;

    while (currentElement) {
        if (canScroll(currentElement)) {
            return currentElement;
        }
        currentElement = currentElement.parentElement;
    }

    return null;
};
